import React from 'react';

const CheckIcon = () => {
    return (
        <svg viewBox='0 0 24 24'>
            <polyline points='4 12 10 18 20 6' />
        </svg>
    );
};

export default CheckIcon;
